import Vue from 'vue'
import Vuex from 'vuex'
import shared from './modules/shared'
import snackbar from './modules/snackbar'
import usuarios from './modules/usuarios'
import auth from './modules/auth'
import aplicativos from './modules/aplicativos'
import recursos from './modules/recursos'
import tokens from './modules/tokens'
import licencas from './modules/licencas'
import tags from './modules/tags'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    shared,
    snackbar,
    usuarios,
    auth,
    aplicativos,
    recursos,
    tokens,
    licencas,
    tags
  }
})
